import React from 'react';

import { flagStyles } from '../settings';

const SvgGU = (): JSX.Element => (
  <img
    style={{
      backgroundPosition: '-2160px 0px',
      ...flagStyles
    }}
    alt=""
  />
);

export default SvgGU;
